/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import StringUtil from "../../Utils/StringUtil";
import ViewModel from "../../ViewModels/ViewModel";
import CommandBarSearchInputModelState from "./CommandBarSearchInputModelState";
import CommandBarSearchInputProps from "./CommandBarSearchInputProps";

export default class CommandBarSearchInputModel extends ViewModel<CommandBarSearchInputModelState> {
    public constructor(private readonly _props: CommandBarSearchInputProps) {
        super({
            initialState: { suchbegriff: "" },
        });
    }

    public get suchbegriff(): string {
        return this.state.suchbegriff;
    }

    public get formClassName(): string {
        if (this._props.variant === "navigation") {
            return "lan-commandbarsearchinput lan-commandbarsearchinput--navigation";
        }

        return "lan-commandbarsearchinput";
    }

    public get istLeerenSichtbar(): boolean {
        return !StringUtil.isEmpty(this.suchbegriff);
    }

    public suchen = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (!this._props.searchOnKeyPress) {
            this._props.onSearch(this.state.suchbegriff);
        }
    };

    public leeren = () => {
        this.setState((nextState) => {
            nextState.suchbegriff = "";
        });
        this._props.onSearch("");
    }

    public aendereSuchbegriff = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget.value;
        if (StringUtil.isEmpty(value)) {
            this.leeren();
        } else {
            this.setState((nextState) => {
                nextState.suchbegriff = value;
            });
        }

        if (this._props.searchOnKeyPress) {
            this._props.onSearch(value);
        }
    };
}
